const style = {
  button: {
    width: 'unset',
    height: 'unset',
  },
};

export default style;
